<!-- 地址列表组件 -->
<template>
  <div class="address-select">
    <vanPopup
      v-model="showPopup"
      position="bottom"
      :round="true"
      :lock-scroll="false"
      @click-overlay="closePopup"
      v-backFn="{ show: showPopup, closeFn: 'closePopup' }"
    >
      <div class="popup-wrap">
        <div class="popup-head">
          <div class="popup-title os-font-16-500">
            {{ isReciceAddress ? '选择修后寄返地址' : '选择上门地址' }}
          </div>
          <div class="popup-close" @click="closePopup"></div>
        </div>
        <div class="popup-content">
          <div v-if="addressList && addressList.length" class="address-list">
            <div
              v-for="(item, index) in addressList"
              :key="index"
              @click="selectAddress(item, index)"
              :class="[
                'address-list-item',
                { 'address-list-item-unsupport': isAddressSupport(item), 'item-space': index != 0 }
              ]"
            >
              <div class="list-item-title os-font-12-400">{{ formateAddress(item) }}</div>
              <div class="list-item-detail os-font-15-500">
                <span class="detail-content">{{ item.detailAddress }}</span>
                <span v-if="item.isDefault" class="default-address"></span>
                <span v-if="isAddressSupport(item)" class="unsupport-address"></span>
              </div>
              <div class="list-item-user os-font-12-400">
                {{ item.receiverName }} {{ item.mobilePhone }}
              </div>
              <div class="list-item-bottom">
                <div class="checkbox-left os-font-12-400">
                  <div v-if="index == currentIndex" class="checked-box">已选</div>
                  <div v-else class="unchecked-box"></div>
                </div>
                <div class="bottom-right">
                  <div
                    @click.stop="deleteAddress(item, index == currentIndex)"
                    class="delete-item"
                  ></div>
                  <div @click.stop="editAddress(item)" class="change-item"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="address-empty os-font-14-500">
            <div class="address-empty-icon"></div>
            {{ isReciceAddress ? '没有收件地址' : '没有上门取件地址' }}
          </div>
        </div>
        <div class="popup-bottom" @click="selectConfirm">
          <div class="popup-button">
            {{ isReciceAddress ? '新建收件地址' : '新建上门地址' }}
          </div>
        </div>
      </div>
    </vanPopup>
    <confirmDialog
      ref="confirmDialog"
      :title="isReciceAddress ? '确定删除修后寄返地址？' : '确定删除上门取件地址？'"
    ></confirmDialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import toast from '@/utils/toast'
import confirmDialog from '@/components/confirmDialog/index.vue'

export default {
  name: 'addressSelect',
  components: {
    confirmDialog
  },
  props: {
    addressList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showPopup: false,
      currentIndex: -1
    }
  },
  computed: {
    ...mapState('repair', [
      'repairType',
      'isReciceAddress',
      'pickupAddress',
      'receiveAddress',
      'isReciceAddress'
    ])
  },
  methods: {
    ...mapMutations('repair', ['setAddressAddALLInfo']),
    openPopup() {
      // 选择默认
      if (this.isReciceAddress) {
        this.currentIndex = this.addressList.findIndex(item => item.id === this.receiveAddress.id)
      } else {
        this.currentIndex = this.addressList.findIndex(item => item.id === this.pickupAddress.id)
      }
      this.preventPageScroll()
      this.showPopup = true
    },
    closePopup() {
      this.restorePageScroll()
      this.showPopup = false
    },
    // 阻止页面滑动
    preventPageScroll() {
      if (this.isPrevent || document.body.classList.contains('isPrevent')) {
        return
      }
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.marginTop = document.body.style.marginTop
      this.height = document.body.style.height
      this.overflow = document.body.style.overflow
      Object.assign(document.body.style, {
        marginTop: -this.scrollTop + 'px',
        height: window.innerHeight + this.scrollTop + 'px',
        overflow: 'hidden'
      })
      document.body.classList.add('isPrevent')
      this.isPrevent = true
    },
    // 恢复页面滑动
    restorePageScroll() {
      if (!this.isPrevent) {
        return
      }
      Object.assign(document.body.style, {
        marginTop: this.marginTop,
        height: this.height,
        overflow: this.overflow
      })
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop
      document.body.classList.remove('isPrevent')
      this.isPrevent = false
    },
    selectConfirm() {
      this.setAddressAddALLInfo({})
      this.$emit('addNewAddress')
    },
    formateAddress(item) {
      return `${item.province} ${item.city} ${item.area}`
    },
    selectAddress(item, index) {
      if (this.repairType == 2) {
        if (this.isReciceAddress) {
          this.currentIndex = index
          this.$emit('selectAddress', item)
          this.$nextTick(() => {
            this.closePopup()
          })
        } else {
          if (item.addressSupport) {
            this.currentIndex = index
            this.$emit('selectAddress', item)
            this.$nextTick(() => {
              this.closePopup()
            })
          } else {
            toast('暂不支持该地区')
          }
        }
      } else {
        if (item.addressSupport) {
          this.currentIndex = index
          this.$emit('selectAddress', item)
          this.$nextTick(() => {
            this.closePopup()
          })
        } else {
          toast('暂不支持该地区')
        }
      }
    },
    deleteAddress(item, isSelect) {
      this.$refs.confirmDialog.openDialog(() => {
        this.$emit('deleteAddress', item, isSelect)
        // 删除选中后清空currentIndex
        if (isSelect) {
          this.currentIndex = -1
        }
      })
    },
    editAddress(item) {
      let newItem = {
        id: item.id,
        receiverName: item.receiverName,
        mobilePhone: item.mobilePhone,
        province: item.province,
        city: item.city,
        area: item.area,
        detailAddress: item.detailAddress,
        isDefault: item.isDefault
      }
      this.setAddressAddALLInfo(newItem)
      this.$emit('editAddress')
    },
    isAddressSupport(item) {
      if (this.repairType == 2) {
        if (this.isReciceAddress) {
          return false
        }
        return !item.addressSupport
      } else {
        return !item.addressSupport
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.address-select {
  .popup-content {
    overflow: hidden;

    .address-list {
      max-height: calc(90vh - 90px);
      height: 444px;
      position: relative;
      overflow-y: auto;
      padding: 12px 16px 78px;
      box-sizing: border-box;

      .address-list-item {
        font-size: 0;
        padding: 16px 16px;
        margin-bottom: 12px;
        border-radius: 6px;
        background: #fafafa;

        .vivo-dark-mode & {
          background-color: #282828;
        }

        &.item-space {
          margin-top: 12px;
        }

        .list-item-title {
          color: #555;
          margin-bottom: 10px;
        }

        .list-item-detail {
          line-height: 18px;
          color: rgba(0, 0, 0, 0.95);
          margin-bottom: 9px;

          .detail-content {
            margin-right: 9px;
          }

          .default-address {
            margin-right: 9px;
            display: inline-block;
            width: 26px;
            height: 16px;
            background: url('~@/assets/img/repair/confirm/wap/default-icon.svg') center center
              no-repeat;
            background-size: contain;
            vertical-align: bottom;
          }

          .unsupport-address {
            vertical-align: bottom;
            display: inline-block;
            width: 76px;
            height: 16px;
            background-image: url('~@/assets/img/repair/confirm/wap/unsupport-icon.svg');
            background-size: 100% 100%;
            position: relative;
            bottom: 1px;
          }
        }

        .list-item-user {
          color: #555;
        }

        .list-item-bottom {
          margin-top: 26px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .checkbox-left {
            color: #415fff;

            .unchecked-box {
              display: flex;
              align-items: center;
              justify-content: center;

              &::before {
                content: '';
                background: url('~@/assets/img/repair/confirm/wap/unselect-icon.svg') center center
                  no-repeat;
                background-size: contain;
                width: 18px;
                height: 18px;
              }
            }

            .checked-box {
              display: flex;
              align-items: center;
              justify-content: center;
              color: #415fff;

              &::before {
                content: '';
                background: url('~@/assets/img/repair/confirm/wap/select-icon.svg') center center
                  no-repeat;
                background-size: contain;
                width: 18px;
                height: 18px;
                margin-right: 7px;
              }
            }
          }

          .bottom-right {
            display: flex;
            align-items: center;

            .delete-item {
              width: 16px;
              height: 16px;
              background: url('~@/assets/img/repair/confirm/wap/delete-address.svg') center center
                no-repeat;
              background-size: contain;
            }

            .change-item {
              margin-left: 16px;
              width: 16px;
              height: 16px;
              background: url('~@/assets/img/repair/confirm/wap/edit-address.svg') center center
                no-repeat;
              background-size: contain;
            }
          }
        }
      }

      .address-list-item-unsupport {
        .list-item-title {
          opacity: 0.4;
        }

        .list-item-detail {
          .detail-content {
            opacity: 0.4;
          }
        }

        .list-item-user {
          opacity: 0.4;
        }

        .list-item-bottom {
          .checkbox-left {
            opacity: 0.4;
          }
        }
      }
    }

    .address-empty {
      color: #999;
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .address-empty-icon {
        margin-bottom: 12px;
        width: 48px;
        height: 48px;
        background: url('~@/assets/img/repair/confirm/wap/website.svg') center center no-repeat;
        background-size: contain;
      }
    }
  }

  .popup-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #fff;

    .vivo-dark-mode & {
      background-color: #f7f7f7;
    }
  }
}
</style>
